export default "__VITE_ASSET__DHL8BJNI__"